import { render, staticRenderFns } from "./TestDetail.vue?vue&type=template&id=b0f4caba&scoped=true&"
import script from "./TestDetail.vue?vue&type=script&lang=js&"
export * from "./TestDetail.vue?vue&type=script&lang=js&"
import style0 from "./TestDetail.vue?vue&type=style&index=0&id=b0f4caba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4caba",
  null
  
)

export default component.exports